import { state_ctrl_factory } from 'ww2_analytics/common/state_ctrl';
import { inject_video_form } from 'ww2_analytics/video/common/forms';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory('video_api', function(service_api, $scope, model) {
        $scope.rows = [];
        service_api.video_count_growing_by_installs(model).then(rows => $scope.rows = rows);
    }),
};


export default inject_video_form({
    url: '/per_day_in_game_growing_by_installs',
    reloadOnSearch: false,
    data: {
        priority: 805,
        title: 'Per day in game installs',
        role: 'video',
    },
    views: {
        '': main_view,
    },
});
